import { z } from 'zod'

import {
  VenueLayoutTableSize,
  VenueLayoutTableType,
} from '../constants/venueLayoutTable'
import { AvailableLayoutTableStatus } from '../constants/availableLayoutTables'
import { listQueryZodFields } from './system'
import { dbEntitySchema } from './system'

export const venueLayoutTableSchema = dbEntitySchema.extend({
  venue: z.string(),
  venueLayoutSection: z.string().optional().nullable(),
  name: z.string(),
  layout: z.string(),
  enable: z.boolean().nullish(),
  type: z.nativeEnum(VenueLayoutTableType),
  size: z.nativeEnum(VenueLayoutTableSize),
  xPos: z.number(),
  yPos: z.number(),
  capacity: z.number().int().min(0).optional().nullable(),
  color: z.string().optional().nullable(),
  borderColor: z.string().optional().nullable(),
  deleted: z.boolean(),
})

export const venueLayoutTableCreateArgsSchema = z.object({
  venueId: z.string(),
  layoutId: z.string(),
  venueLayoutSectionId: z.string().optional().nullable(),
  name: z.string(),
  type: z.nativeEnum(VenueLayoutTableType),
  size: z.nativeEnum(VenueLayoutTableSize),
  xPos: z.coerce.number(),
  yPos: z.coerce.number(),
  capacity: z.number().int().min(0).optional().nullable(),
})

/** Partial API shape; `venueLayoutSectionId: null` clears the section ref (create schema treats null like omit). */
export const venueLayoutTableUpdateByIdArgsSchema =
  venueLayoutTableCreateArgsSchema
    .omit({ venueId: true, layoutId: true })
    .partial()

export const venueLayoutTableListQuerySchema = z.object({
  ...listQueryZodFields,
  venueId: z.string().or(z.array(z.string())).optional().nullable(),
  layoutId: z.string().or(z.array(z.string())).optional().nullable(),
  venueLayoutSectionId: z
    .string()
    .or(z.array(z.string()))
    .optional()
    .nullable(),
})

export const venueLayoutTablesByLayoutListQuerySchema = z.object({
  ...listQueryZodFields,
})

export const venueLayoutTableListResponseSchema = z.object({
  data: z.array(venueLayoutTableSchema),
})

//available layout tables

export const venueAvailableLayoutTableSchema = venueLayoutTableSchema.extend({
  status: z.nativeEnum(AvailableLayoutTableStatus),
  guests: z
    .array(
      z.object({
        id: z.string(),
        color: z.string(),
        borderColor: z.string(),
        admissionGroupId: z.string(),
        initials: z.string().nullish(),
        name: z.string(),
        minimumSpend: z.number().nullish(),
        spent: z.number().nullish(),
        vip: z.boolean().nullish(),
        comp: z.boolean().nullish(),
      })
    )
    .optional()
    .nullable(),
})

export const venueAvailableLayoutTableListQuerySchema = z.object({
  ...listQueryZodFields,
  date: z.coerce.date(),
  venueId: z.string().or(z.array(z.string())).optional().nullable(),
  venueLayoutSectionId: z
    .string()
    .or(z.array(z.string()))
    .optional()
    .nullable(),
  layoutId: z.string().or(z.array(z.string())).optional().nullable(),
  tableId: z.string().or(z.array(z.string())).optional().nullable(),
})

export const venueAvailableLayoutTableListResponseSchema = z.object({
  data: z.array(venueAvailableLayoutTableSchema),
})
